<template>
    <div>
        <destination-form
            :is-destination-form-sidebar-active.sync="isDestinationFormSidebarActive"
            :destination-data="destinationData"
            @refetch-data="refetchData" 
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    />
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="updateDestination()"
                            >
                                <span class="text-nowrap">Add Review</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                ref="refDestinationListTable"
                :items="destinations"
                responsive
                :fields="tableColumns"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No matching records found"
                :sort-desc.sync="isSortDirDesc"
                class="position-relative"
            >
                <template #cell(title)="data">
                    {{ data.item.title[currentLocale] }}
                </template>
                <template #cell(slug)="data">
                    {{ data.item.slug[currentLocale] }}
                </template>
                <template #cell(is_active)="data">
                    <b-badge
                        pill
                        :variant="`light-${resolveDestinationStatusVariant(data.item.is_active)}`"
                        class="text-capitalize"
                    >
                        {{ resolveDestinationStatusnameVariant(data.item.is_active) }} 
                    </b-badge>
                </template>
                <template #cell(action)="data">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateDestination(data.item)" variant="outline-success">Edit</b-button>
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(data.item.id)" variant="outline-danger">Delete</b-button>
                </template>
            </b-table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalDestinations"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { ref,onUnmounted } from '@vue/composition-api'
import draggable from 'vuedraggable'

import DestinationForm from './DestinationForm.vue';
import useDestinationList from './useDestinationList'
import reviewStoreModule from '../reviewStoreModule'

export default {
    components:{
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
        DestinationForm, draggable
    },

    directives:{
        'b-modal': VBModal,
        Ripple
    },

    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },

    setup() {

        const REVIEW_STORE_MODULE_NAME = 'app-review';
        if (!store.hasModule(REVIEW_STORE_MODULE_NAME)) store.registerModule(REVIEW_STORE_MODULE_NAME, reviewStoreModule)
        onUnmounted(() => {
            if (store.hasModule(REVIEW_STORE_MODULE_NAME)) store.unregisterModule(REVIEW_STORE_MODULE_NAME)
        });

        const {
            tableColumns,
            updateDestination,
            searchQuery,
            isDestinationFormSidebarActive,
            destinationData,
            refetchData,
            fetchData,
            refDestinationListTable,
            sortBy,
            statusFilter,
            perPage,
            currentPage,
            isSortDirDesc,
            dataMeta,
            totalDestinations,
            destinations,
            resolveDestinationStatusVariant,
            resolveDestinationStatusnameVariant,
            deleteData,
        } = useDestinationList()

        fetchData()

        return {
            tableColumns,
            updateDestination,
            searchQuery,
            isDestinationFormSidebarActive,
            destinationData,
            refetchData,
            fetchData,
            refDestinationListTable,
            sortBy,
            statusFilter,
            perPage,
            currentPage,
            isSortDirDesc,
            dataMeta,
            totalDestinations,
            destinations,
            resolveDestinationStatusVariant,
            resolveDestinationStatusnameVariant,
            deleteData,
        }
    },

    methods: {
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm(`Please confirm that you want to delete Destination ID: ${id}`, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                    this.deleteData(id)
                }
            })
        },
    },
}
</script>